// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactUs_subText__KVj-9 {
    color: rgba(255, 255, 255, 0.60);
}

.ContactUs_cardTitle_1__lu9ZB {
    color: #B7CF53;
    font-size: 3.6rem;
}

.ContactUs_cardTitle_2__HGDBu {
    color: #80B036;
    font-size: 3.6rem;
}

.ContactUs_cardTitle_3__\\+3AOW {
    color: #45852E;
    font-size: 3.6rem;
}

.ContactUs_cardTitle_4__psOLO {
    color: #323E4A;
    font-size: 3.6rem;
}

.ContactUs_cardSubText__beuSf {
    color: #404040;
}

.ContactUs_cardSubText_1__yFSnm {
    color: #272727;
    font-size: 0.9rem;
}

.ContactUs_noMargin__DWZMT {
    margin: 0px;
  }
  .ContactUs_square__8OmNe {
    width: 80px;
    height: 80px;
    margin: 5px;
    background-color: #EBEBEB;
    justify-content: center;
    align-items: center;
  }

  .ContactUs_square__8OmNe:hover {
    background-color: #45852e;
    .ContactUs_iconCenter__SCElT {
        top: 35%;
        left: 35%;
        position: relative;
        color: #fff;
      }
  }

  .ContactUs_iconCenter__SCElT {
    top: 35%;
    left: 35%;
    position: relative;
    font-size: 20px;
  }
 
  .ContactUs_mega__Vcurw{
    margin-top: 20px;
  }
  .ContactUs_border_contact__x3tVE{
    border-right: 1px solid gray;
  }
  .ContactUs_face_icon__u6Ykb{
    width: 80px;
    height: 80px;
    transition: background-color .3s linear;

  }
  .ContactUs_face_icon1__NcjTo{
    background: #B7CF53;
backdrop-filter: blur(8px);
  }
.ContactUs_face_icon2__yh--c{
  background: #80B036;
  backdrop-filter: blur(8px);
  }
  .ContactUs_face_icon3__SbW60{
    background: #45852E;
backdrop-filter: blur(8px);
  }
  .ContactUs_square_change__kCM6j{
    position: relative;
    width: 80px;
    height: 80px;
    margin: 5px;
    background-color: #EBEBEB;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .ContactUs_square_change__kCM6j:hover .ContactUs_face_icon__u6Ykb,.ContactUs_square_change__kCM6j{
    background-color: #333E48;
  }
  .ContactUs_face_image__txANz{
    position: absolute;
    inset: 0px 0px 0px 30px;
    scale: 0;
    transition: all .3s ease-out;
  }
  .ContactUs_square_change__kCM6j:hover .ContactUs_face_image__txANz{
    position: absolute;
    inset: 0px 0px 0px 0px;
    scale: 1;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/portalComponents/ContactUs.module.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB;QACI,QAAQ;QACR,SAAS;QACT,kBAAkB;QAClB,WAAW;MACb;EACJ;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,YAAY;IACZ,uCAAuC;;EAEzC;EACA;IACE,mBAAmB;AACvB,0BAA0B;EACxB;AACF;EACE,mBAAmB;EACnB,0BAA0B;EAC1B;EACA;IACE,mBAAmB;AACvB,0BAA0B;EACxB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,QAAQ;IACR,4BAA4B;EAC9B;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;EACV","sourcesContent":[".subText {\n    color: rgba(255, 255, 255, 0.60);\n}\n\n.cardTitle_1 {\n    color: #B7CF53;\n    font-size: 3.6rem;\n}\n\n.cardTitle_2 {\n    color: #80B036;\n    font-size: 3.6rem;\n}\n\n.cardTitle_3 {\n    color: #45852E;\n    font-size: 3.6rem;\n}\n\n.cardTitle_4 {\n    color: #323E4A;\n    font-size: 3.6rem;\n}\n\n.cardSubText {\n    color: #404040;\n}\n\n.cardSubText_1 {\n    color: #272727;\n    font-size: 0.9rem;\n}\n\n.noMargin {\n    margin: 0px;\n  }\n  .square {\n    width: 80px;\n    height: 80px;\n    margin: 5px;\n    background-color: #EBEBEB;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .square:hover {\n    background-color: #45852e;\n    .iconCenter {\n        top: 35%;\n        left: 35%;\n        position: relative;\n        color: #fff;\n      }\n  }\n\n  .iconCenter {\n    top: 35%;\n    left: 35%;\n    position: relative;\n    font-size: 20px;\n  }\n \n  .mega{\n    margin-top: 20px;\n  }\n  .border_contact{\n    border-right: 1px solid gray;\n  }\n  .face_icon{\n    width: 80px;\n    height: 80px;\n    transition: background-color .3s linear;\n\n  }\n  .face_icon1{\n    background: #B7CF53;\nbackdrop-filter: blur(8px);\n  }\n.face_icon2{\n  background: #80B036;\n  backdrop-filter: blur(8px);\n  }\n  .face_icon3{\n    background: #45852E;\nbackdrop-filter: blur(8px);\n  }\n  .square_change{\n    position: relative;\n    width: 80px;\n    height: 80px;\n    margin: 5px;\n    background-color: #EBEBEB;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n  }\n  .square_change:hover .face_icon,.square_change{\n    background-color: #333E48;\n  }\n  .face_image{\n    position: absolute;\n    inset: 0px 0px 0px 30px;\n    scale: 0;\n    transition: all .3s ease-out;\n  }\n  .square_change:hover .face_image{\n    position: absolute;\n    inset: 0px 0px 0px 0px;\n    scale: 1;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subText": `ContactUs_subText__KVj-9`,
	"cardTitle_1": `ContactUs_cardTitle_1__lu9ZB`,
	"cardTitle_2": `ContactUs_cardTitle_2__HGDBu`,
	"cardTitle_3": `ContactUs_cardTitle_3__+3AOW`,
	"cardTitle_4": `ContactUs_cardTitle_4__psOLO`,
	"cardSubText": `ContactUs_cardSubText__beuSf`,
	"cardSubText_1": `ContactUs_cardSubText_1__yFSnm`,
	"noMargin": `ContactUs_noMargin__DWZMT`,
	"square": `ContactUs_square__8OmNe`,
	"iconCenter": `ContactUs_iconCenter__SCElT`,
	"mega": `ContactUs_mega__Vcurw`,
	"border_contact": `ContactUs_border_contact__x3tVE`,
	"face_icon": `ContactUs_face_icon__u6Ykb`,
	"face_icon1": `ContactUs_face_icon1__NcjTo`,
	"face_icon2": `ContactUs_face_icon2__yh--c`,
	"face_icon3": `ContactUs_face_icon3__SbW60`,
	"square_change": `ContactUs_square_change__kCM6j`,
	"face_image": `ContactUs_face_image__txANz`
};
export default ___CSS_LOADER_EXPORT___;
